const style = (theme) => {
  const output = {
    root: {},
    carousel: {
      '& .slick-track': {
        display: 'flex',
      },
    },
    slick: {
      position: 'relative',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    carouselImg: {
      '& img': {
        maxHeight: '40vh',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
